import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-5af9973e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fr-panel" };
const _hoisted_2 = { class: "fr-panel__title" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "ic" }, "📝", -1));
const _hoisted_4 = { class: "fr-fld" };
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = { class: "fr-fld-err" };
const _hoisted_7 = {
    class: "fr-fld",
    for: "fr-gender"
};
const _hoisted_8 = ["value"];
const _hoisted_9 = { class: "fr-fld" };
const _hoisted_10 = { class: "fr-phone-row" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("select", {
    id: "fr-country-code",
    "aria-label": "country code"
}, null, -1));
const _hoisted_12 = ["value", "maxlength"];
const _hoisted_13 = { class: "fr-fld-err" };
const _hoisted_14 = { class: "fr-fld" };
const _hoisted_15 = {
    key: 0,
    class: "fr-fld-opt"
};
const _hoisted_16 = ["placeholder"];
const _hoisted_17 = { class: "fr-fld-err" };
const _hoisted_18 = { class: "fr-fld" };
const _hoisted_19 = { class: "fr-chips" };
const _hoisted_20 = ["aria-pressed", "onClick"];
const _hoisted_21 = { class: "fr-fld" };
const _hoisted_22 = ["placeholder"];
const _hoisted_23 = { class: "fr-policy" };
const _hoisted_24 = { class: "fr-policy__label" };
const _hoisted_25 = ["href"];
const _hoisted_26 = { class: "fr-fld-err" };
const _hoisted_27 = { class: "fr-btnrow" };
const _hoisted_28 = ["disabled"];
import countryCodeList from '@vue/services/country-code';
import { t } from '@vue/services/interval-lang';
import { bookingState, PURPOSES } from '@vue/services/interval-store';
import BookingSummary from '@vue/components/interval/BookingSummary.vue';
import TomSelect from 'tom-select';
import { computed, onMounted, ref, watch, inject } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerForm',
    props: {
        sending: { type: Boolean }
    },
    emits: ['back', 'submit'],
    setup(__props, { emit: __emit }) {
        /**
         * 填寫訂位資料（原型步驟 3）。
         *
         * 驗證規則照抄明水然 ReservationForm 的判定（required / nameStrict /
         * taiwanPhone / emailStrict），但不引入 vee-validate：本頁欄位少、
         * 規則固定，純函式驗證比較好讀，也不會把明水然那套 Bootstrap 樣式拖進來。
         */
        const emits = __emit;
        const props = __props;
        /**
         * 選單的值是 ISO 代碼（'tw'）而不是撥號碼。
         *
         * 撥號碼會重複（美／加同為 +1、哈／俄同為 +7），TomSelect 的 valueField
         * 一旦重複，後出現的那筆會被 addOption 靜默丟棄，加拿大與俄羅斯就永遠選不到。
         * 要送 API 的撥號碼一律由 countryCode 這個 computed 取得。
         *
         * ⚠️ 這個 select 刻意不用 v-model：TomSelect 會接管原生 select 並自己
         * 建一組 DOM，Vue 的 v-model 每次重繪都會跟它搶同一個節點，結果是原生
         * select 沒被藏起來、旁邊又多一個接管失敗的控制項。改成單向：
         * TomSelect 負責畫面與互動，選了才回寫這個 ref。
         */
        const selectedCountry = ref('tw');
        const countryCode = computed(() => countryCodeList.find((item) => item.countryCode === selectedCountry.value)?.value ?? '+886');
        const errors = ref({ name: '', phone: '', email: '', policy: '' });
        /**
         * 隱私權同意（與明水然系一致的必勾條件）。
         *
         * 網址由 blade 以 props 帶入，來源是獨立的 PRIVACY_URL 設定：
         * 隱私權條款是集團層級的文件，未必掛在本站底下，寫死本站路由會綁死落點。
         * 未設定時 blade 會退回本站的 page/privacy，連結不會壞。
         */
        const policyAgreed = ref(false);
        const privacyUrl = inject('privacyUrl', '');
        /**
         * 性別選項。值必須與後端 Customer::setGender() 一致（0=其他、1=男性、2=女性），
         * 送出非 0/1/2 會被後端靜默轉成 null。選填欄位，預設 0（其他/不透漏）。
         */
        const genderOptions = computed(() => [
            { value: 0, text: t('bk.gender.other') },
            { value: 1, text: t('bk.gender.male') },
            { value: 2, text: t('bk.gender.female') },
        ]);
        const phoneMaxLength = computed(() => (countryCode.value === '+886' ? 10 : 15));
        /**
         * Email 必填與否依國碼：+886 本國客選填（2026-09-10 需求），外國客仍必填。
         *
         * 外國客不放寬不是體感問題，是流程會斷：他們的驗證碼只有 Email 一條路
         * （後端 otpChannel() 對非 +886 一律回 email），訂位通知也寄不到國外門號。
         * 後端 ReserveController::validateReservationEmailOrFail() 是同一套判定，
         * 改這裡務必連後端一起改，否則前端放行、送出才被擋。
         */
        const emailRequired = computed(() => countryCode.value !== '+886');
        watch(countryCode, (v) => {
            bookingState.countryCode = v;
            // 換國別碼 → 台灣／國外格式不同，已顯示的錯誤要重驗
            if (errors.value.phone) {
                errors.value.phone = validatePhone(bookingState.phone);
            }
            // Email 的必填與否也跟著國碼變：從外國切回 +886 時，原本那句「請填寫這個欄位」
            // 已經不成立，留著會讓客人以為還是非填不可。
            if (errors.value.email) {
                errors.value.email = validateEmail(bookingState.email);
            }
        });
        onMounted(() => {
            bookingState.countryCode = countryCode.value;
            initCountrySelect();
        });
        // ---- 欄位驗證 ----
        /** 姓名：必填，僅限中英文、空白、. 與 -。 */
        function validateName(v) {
            const value = (v || '').trim();
            if (!value) {
                return 'bk.errRequired';
            }
            return /^[\p{L}\s.\-]+$/u.test(value) ? '' : 'bk.errName';
        }
        /** 手機：台灣為 9 碼開頭 9 或 10 碼開頭 09；國外為純數字 6~15 碼。 */
        function validatePhone(v) {
            const value = (v || '').trim();
            if (!value) {
                return 'bk.errRequired';
            }
            if (countryCode.value === '+886') {
                const ok = (value.length === 9 && value.startsWith('9')) ||
                    (value.length === 10 && value.startsWith('09'));
                return ok ? '' : 'bk.errPhone';
            }
            return /^\d{6,15}$/.test(value) ? '' : 'bk.errPhone';
        }
        /**
         * Email：+886 本國客選填、外國客必填（見 emailRequired）；
         * 有填就一定要格式正確，且不可含逗號／空白等非法字元。
         * 放寬的是「可不填」，不是「可亂填」。
         */
        function validateEmail(v) {
            const value = (v || '').trim();
            if (!value) {
                return emailRequired.value ? 'bk.errRequired' : '';
            }
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                return 'bk.errEmail';
            }
            return /[(),:;<>[\]\s]/.test(value) ? 'bk.errEmailStrict' : '';
        }
        function validateField(field) {
            const validators = { name: validateName, phone: validatePhone, email: validateEmail };
            errors.value[field] = validators[field](bookingState[field]);
            return !errors.value[field];
        }
        function validateAll() {
            // 全部都要跑，不可短路：短路會讓後面的欄位不顯示紅字，客人得一個一個試
            const okName = validateField('name');
            const okPhone = validateField('phone');
            const okEmail = validateField('email');
            errors.value.policy = policyAgreed.value ? '' : 'bk.errPolicy';
            return okName && okPhone && okEmail && !errors.value.policy;
        }
        function onPhoneInput(e) {
            const el = e.target;
            bookingState.phone = el.value.replace(/\D/g, '').slice(0, phoneMaxLength.value);
        }
        function togglePurpose(p) {
            const i = bookingState.purpose.indexOf(p);
            if (i < 0) {
                bookingState.purpose.push(p);
            }
            else {
                bookingState.purpose.splice(i, 1);
            }
        }
        function submit() {
            if (!validateAll()) {
                return;
            }
            emits('submit');
        }
        function initCountrySelect() {
            const optionRender = (data, escape) => `<div class="fr-country-option">
      <span class="flag-icon flag-icon-${escape(data.countryCode)}"></span>
      <span class="fr-country-name">${escape(data.zhTW)}</span>
      <span class="fr-country-dial">${escape(data.value)}</span>
    </div>`;
            // 收合時只顯示國旗與號碼，避免把右邊的電話輸入框擠掉
            const itemRender = (data, escape) => `<div class="fr-country-item">
      <span class="flag-icon flag-icon-${escape(data.countryCode)}"></span>
      <span>${escape(data.value)}</span>
    </div>`;
            const select = new TomSelect('#fr-country-code', {
                // 跟著清單長度走 = 全部顯示。寫死數字會在清單變長時靜默截掉國家
                maxOptions: countryCodeList.length,
                valueField: 'countryCode',
                labelField: 'zhTW',
                // 中文名、英文名、撥號碼、ISO 代碼都可以搜
                searchField: ['zhTW', 'enUS', 'value', 'countryCode'],
                create: false,
                allowEmptyOption: false,
                options: countryCodeList,
                items: ['tw'],
                // ⚠️ wrapperClass 是「取代」預設的 ts-wrapper，不是附加。
                // 只寫 fr-country-select 會讓 tom-select 基礎樣式的
                // `.ts-wrapper { position: relative }` 失效，下拉選單（absolute）
                // 就會找不到定位基準，直接飛到文件左上角。原生 class 必須留著。
                wrapperClass: 'ts-wrapper fr-country-select',
                render: {
                    option: optionRender,
                    item: itemRender,
                    no_results: () => `<div class="fr-country-empty">${t('bk.countryNoResult')}</div>`,
                },
            });
            select.on('change', (value) => {
                selectedCountry.value = value;
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("h2", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('bk.s3title')), 1)
                ]),
                _createVNode(BookingSummary),
                _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(t)('bk.name')), 1),
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(bookingState).name) = $event)),
                    class: _normalizeClass(["fr-input", { invalid: errors.value.name }]),
                    placeholder: _unref(t)('bk.namePlaceholder'),
                    maxlength: "30",
                    autocomplete: "name",
                    onBlur: _cache[1] || (_cache[1] = ($event) => (validateField('name')))
                }, null, 42, _hoisted_5), [
                    [_vModelText, _unref(bookingState).name]
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(errors.value.name ? _unref(t)(errors.value.name) : ''), 1),
                _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)('bk.gender')), 1),
                _withDirectives(_createElementVNode("select", {
                    id: "fr-gender",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(bookingState).gender) = $event)),
                    class: "fr-input fr-select"
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(genderOptions.value, (o) => {
                        return (_openBlock(), _createElementBlock("option", {
                            key: o.value,
                            value: o.value
                        }, _toDisplayString(o.text), 9, _hoisted_8));
                    }), 128))
                ], 512), [
                    [
                        _vModelSelect,
                        _unref(bookingState).gender,
                        void 0,
                        { number: true }
                    ]
                ]),
                _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('bk.phone')), 1),
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("input", {
                        value: _unref(bookingState).phone,
                        class: _normalizeClass(["fr-input", { invalid: errors.value.phone }]),
                        placeholder: "0912345678",
                        inputmode: "numeric",
                        maxlength: phoneMaxLength.value,
                        autocomplete: "tel",
                        onInput: onPhoneInput,
                        onBlur: _cache[3] || (_cache[3] = ($event) => (validateField('phone')))
                    }, null, 42, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(errors.value.phone ? _unref(t)(errors.value.phone) : ''), 1),
                _createElementVNode("label", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_unref(t)('bk.email')), 1),
                    (!emailRequired.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(t)('bk.emailOptional')), 1))
                        : _createCommentVNode("", true)
                ]),
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(bookingState).email) = $event)),
                    type: "email",
                    class: _normalizeClass(["fr-input", { invalid: errors.value.email }]),
                    placeholder: _unref(t)('bk.emailPlaceholder'),
                    maxlength: "100",
                    autocomplete: "email",
                    onBlur: _cache[5] || (_cache[5] = ($event) => (validateField('email')))
                }, null, 42, _hoisted_16), [
                    [_vModelText, _unref(bookingState).email]
                ]),
                _createElementVNode("div", _hoisted_17, _toDisplayString(errors.value.email ? _unref(t)(errors.value.email) : ''), 1),
                _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(t)('bk.purpose')), 1),
                _createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PURPOSES), (p) => {
                        return (_openBlock(), _createElementBlock("button", {
                            key: p,
                            type: "button",
                            class: _normalizeClass({ on: _unref(bookingState).purpose.includes(p) }),
                            "aria-pressed": _unref(bookingState).purpose.includes(p),
                            onClick: ($event) => (togglePurpose(p))
                        }, _toDisplayString(_unref(t)('bk.purpose.' + p)), 11, _hoisted_20));
                    }), 128))
                ]),
                _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(t)('bk.note')), 1),
                _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(bookingState).note) = $event)),
                    class: "fr-input",
                    rows: "2",
                    maxlength: "200",
                    placeholder: _unref(t)('bk.notePlaceholder')
                }, null, 8, _hoisted_22), [
                    [_vModelText, _unref(bookingState).note]
                ]),
                _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((policyAgreed).value = $event)),
                            type: "checkbox",
                            class: "fr-policy__box",
                            onChange: _cache[8] || (_cache[8] = ($event) => (policyAgreed.value && (errors.value.policy = '')))
                        }, null, 544), [
                            [_vModelCheckbox, policyAgreed.value]
                        ]),
                        _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(_unref(t)('bk.policyAgree')) + " ", 1),
                            _createElementVNode("a", {
                                href: _unref(privacyUrl),
                                target: "_blank",
                                rel: "noopener"
                            }, _toDisplayString(_unref(t)('bk.policyName')), 9, _hoisted_25)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(errors.value.policy ? _unref(t)(errors.value.policy) : ''), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "fr-btn fr-btn--ghost",
                        onClick: _cache[9] || (_cache[9] = ($event) => (emits('back')))
                    }, _toDisplayString(_unref(t)('common.prev')), 1),
                    _createElementVNode("button", {
                        type: "button",
                        class: "fr-btn",
                        disabled: props.sending,
                        onClick: submit
                    }, _toDisplayString(props.sending ? _unref(t)('bk.sending') : _unref(t)('bk.startBooking')), 9, _hoisted_28)
                ])
            ]));
        };
    }
});
